import { Injectable } from '@angular/core';

import * as FileSaver from 'file-saver';

@Injectable({
	providedIn: 'root',
})
export class ExportDataService {
	exportExcel(fileName: string, buffer: any) {
		const EXCEL_TYPE =
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
		const EXCEL_EXTENSION = '.xlsx';

		import('xlsx').then((xlsx) => {
			const worksheet = xlsx.utils.json_to_sheet(buffer);
			const workbook = {
				Sheets: { data: worksheet },
				SheetNames: ['data'],
			};
			const excelBuffer: any = xlsx.write(workbook, {
				bookType: 'xlsx',
				type: 'array',
			});

			const data: Blob = new Blob([excelBuffer], {
				type: EXCEL_TYPE,
			});

			FileSaver.saveAs(
				data,
				fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
			);
		});
	}

	exportCSV(fileName: string, buffer: any) {
		const FILE_TYPE = 'text/csv;charset=utf-8;';
		const FILE_EXTENSION = '.csv';
		const separator = ',';
		const keys = Object.keys(buffer[0]);

		const content =
			keys.join(separator) +
			'\n' +
			buffer
				.map((row) => {
					return keys
						.map((k) => {
							let cell =
								row[k] === null || row[k] === undefined
									? ''
									: row[k];

							return cell;
						})
						.join(separator);
				})
				.join('\n');
		const data: Blob = new Blob([content], {
			type: FILE_TYPE,
		});

		FileSaver.saveAs(
			data,
			fileName + '_export_' + new Date().getTime() + FILE_EXTENSION
		);
	}

	exportFile(typeFile: number, fileName: string, buffer: any) {
		let FILE_TYPE = '';
		let FILE_EXTENSION = '';

		if (typeFile === 1) {
			FILE_TYPE = 'text/csv;charset=utf-8;';
			FILE_EXTENSION = '.csv';
		}

		if (typeFile === 2) {
			FILE_TYPE =
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
			FILE_EXTENSION = '.xls';
		}

		const data: Blob = new Blob([buffer], {
			type: FILE_TYPE,
		});

		FileSaver.saveAs(
			data,
			fileName + '_export_' + new Date().getTime() + FILE_EXTENSION
		);
	}
}
